import React from 'react';
import Section from '../../Section';
import CouponsManager from './CouponsManager';
import Alert from "../../Alert";

function CouponsManagerSection() {
    return (
        <Section
            title="Manage Coupons"
            subtitle="Manage discount codes."
            preview="Create percentage or fixed amount discounts, set expiration dates, and track redemptions."
            id="coupons-manager"
        >
            <CouponsManager />
        </Section>

    );

}

export default CouponsManagerSection;